export default {
  log: function(args) {
    console.error(args)
  }
}
